import { useClient } from '~/stores/client'

export function useFavoritesCount() {
  const client = useClient()
  const favoritesCount = useState<number>('favoritesCount', () => 0)
  let requestId = 0

  async function refreshFavoritesCount() {
    const currentRequestId = ++requestId
    if (!client.isAuthenticated || client.getClientId === null) {
      favoritesCount.value = 0
      return
    }

    const response = await mainFetch('me/favorites/counts')
    if (currentRequestId !== requestId) return

    const count = response.data.value?.[client.getActiveCompany === null ? 'vacancy' : 'summary']
    if (!response.error.value && typeof count === 'number') {
      favoritesCount.value = count
    }
  }

  watch(
    [() => client.isAuthenticated, () => client.getActiveCompany?.id ?? null],
    () => { void refreshFavoritesCount() },
    { immediate: true },
  )

  return { favoritesCount, refreshFavoritesCount }
}
